const initialState = {
  domains: [],
  isLoading: false,
  error: null,
  shouldRefreshApplicant: false,
};

const MAILBOX_ACTIONS = {
  SET_DOMAINS: 'MAILBOX_SET_DOMAINS',
  SET_LOADING: 'MAILBOX_SET_LOADING',
  SET_ERROR: 'MAILBOX_SET_ERROR',
  TRIGGER_APPLICANT_REFRESH: 'MAILBOX_TRIGGER_APPLICANT_REFRESH',
  CLEAR_REFRESH_FLAG: 'MAILBOX_CLEAR_REFRESH_FLAG',
};

const actionHandlers = {
  [MAILBOX_ACTIONS.SET_DOMAINS]: (state, action) => ({
    ...state,
    domains: action.payload,
    error: null,
  }),
  
  [MAILBOX_ACTIONS.SET_LOADING]: (state, action) => ({
    ...state,
    isLoading: action.payload,
  }),
  
  [MAILBOX_ACTIONS.SET_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),
  
  [MAILBOX_ACTIONS.TRIGGER_APPLICANT_REFRESH]: (state) => ({
    ...state,
    shouldRefreshApplicant: true,
  }),
  
  [MAILBOX_ACTIONS.CLEAR_REFRESH_FLAG]: (state) => ({
    ...state,
    shouldRefreshApplicant: false,
  }),
};

const mailboxReducer = (state = initialState, action) => {
  const handler = actionHandlers[action.type];
  return handler ? handler(state, action) : state;
};

export const mailboxActions = {
  setDomains: (domains) => ({
    type: MAILBOX_ACTIONS.SET_DOMAINS,
    payload: domains,
  }),
  
  setLoading: (isLoading) => ({
    type: MAILBOX_ACTIONS.SET_LOADING,
    payload: isLoading,
  }),
  
  setError: (error) => ({
    type: MAILBOX_ACTIONS.SET_ERROR,
    payload: error,
  }),
  
  triggerApplicantRefresh: () => ({
    type: MAILBOX_ACTIONS.TRIGGER_APPLICANT_REFRESH,
  }),
  
  clearRefreshFlag: () => ({
    type: MAILBOX_ACTIONS.CLEAR_REFRESH_FLAG,
  }),
};

export default mailboxReducer; 